.selected-document-modal-footer {
    display: flex;
    padding: 16px;
    justify-content: flex-end;
    position: sticky;
    bottom: 0;
    background: var(--white);
    z-index: 1;
}

.icon-section-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 50%;
}
